{
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "左のリストから会話を選択してください",
    "CSAT_REPLY_MESSAGE": "会話の評価にご協力をお願いいたします。",
    "404": "会話が見つかりませんでした。もう一度お試しください。",
    "SWITCH_VIEW_LAYOUT": "レイアウトを変更",
    "DASHBOARD_APP_TAB_MESSAGES": "メッセージ",
    "UNVERIFIED_SESSION": "このユーザーの身元は確認されていません",
    "NO_MESSAGE_1": "おっと！受信トレイに顧客からのメッセージがないようです。",
    "NO_MESSAGE_2": " あなたのページにメッセージを送る",
    "NO_INBOX_1": "まだ受信トレイを追加していないようです。",
    "NO_INBOX_2": " 始めましょう",
    "NO_INBOX_AGENT": "あなたに受信トレイが設定されていないようです。管理者に問い合わせてください。",
    "SEARCH_MESSAGES": "会話中のメッセージの検索",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "EMPTY_STATE": {
      "CMD_BAR": "コマンドメニューを開く",
      "KEYBOARD_SHORTCUTS": "キーボードショートカットを表示する"
    },
    "SEARCH": {
      "TITLE": "メッセージを検索",
      "RESULT_TITLE": "検索結果",
      "LOADING_MESSAGE": "データを集めています...",
      "PLACEHOLDER": "テキストを入力してメッセージを検索します",
      "NO_MATCHING_RESULTS": "該当結果が見つかりませんでした。"
    },
    "UNREAD_MESSAGES": "未読メッセージ",
    "UNREAD_MESSAGE": "未読メッセージ",
    "CLICK_HERE": "ここをクリック",
    "LOADING_INBOXES": "受信トレイを読み込み中",
    "LOADING_CONVERSATIONS": "会話データを読み込んでいます",
    "CANNOT_REPLY": "以下の理由で返信できません：",
    "24_HOURS_WINDOW": "24時間以内のメッセージウィンドウの制限",
    "48_HOURS_WINDOW": "48時間以内のメッセージウィンドウの制限",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "NOT_ASSIGNED_TO_YOU": "この会話はあなたに割り当てられていません。自分に割り当てますか？",
    "ASSIGN_TO_ME": "自分に割り当て",
    "BOT_HANDOFF_MESSAGE": "You are responding to a conversation which is currently handled by an assistant or a bot.",
    "BOT_HANDOFF_ACTION": "Mark open and assign to you",
    "BOT_HANDOFF_REOPEN_ACTION": "Mark conversation open",
    "BOT_HANDOFF_SUCCESS": "Conversation has been handed over to you",
    "BOT_HANDOFF_ERROR": "Failed to take over the conversation. Please try again.",
    "TWILIO_WHATSAPP_CAN_REPLY": "この会話にはテンプレートメッセージでしか返信できません。",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24時間以内のメッセージウィンドウの制限",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won’t be able to send messages from this conversation anymore.",
    "REPLYING_TO": "以下に返信：",
    "REMOVE_SELECTION": "選択項目を削除",
    "DOWNLOAD": "ダウンロード",
    "UNKNOWN_FILE_TYPE": "不明なファイル",
    "SAVE_CONTACT": "連絡先を保存",
    "NO_CONTENT": "表示するコンテンツがありません",
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} が連絡先を共有しました",
      "LOCATION": "{sender} が位置情報を共有しました",
      "FILE": "{sender} がファイルを共有しました",
      "MEETING": "{sender} がミーティングを開始しました"
    },
    "UPLOADING_ATTACHMENTS": "添付ファイルをアップロード中...",
    "REPLIED_TO_STORY": "あなたのストーリーに返信",
    "UNSUPPORTED_MESSAGE": "このメッセージはサポートされていません。Facebook / Instagram で表示できます。",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "このメッセージはサポートされていません。Facebook Messengerでこのメッセージを表示できます。",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "このメッセージはサポートされていません。このメッセージは Instagram で表示できます。",
    "UNSUPPORTED_MESSAGE_TIKTOK": "This message is unsupported. You can view this message on the TikTok app.",
    "UNSUPPORTED_MESSAGE_WHATSAPP": "This message is unsupported. You can view this message on the WhatsApp app.",
    "SUCCESS_DELETE_MESSAGE": "メッセージの削除に成功",
    "FAIL_DELETE_MESSSAGE": "メッセージを削除できませんでした！もう一度お試しください",
    "NO_RESPONSE": "返信なし",
    "RESPONSE": "回答",
    "RATING_TITLE": "評価",
    "FEEDBACK_TITLE": "フィードバック",
    "REPLY_MESSAGE_NOT_FOUND": "メッセージは利用できません",
    "CARD": {
      "SHOW_LABELS": "ラベルを表示",
      "HIDE_LABELS": "ラベルを隠す",
      "LABELS_COUNT": "{count} labels"
    },
    "VOICE_CALL": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NO_ANSWER": "No answer",
      "NO_ANSWER_OUTBOUND_LABEL": "No answer",
      "NO_ANSWER_OUTBOUND_SUBTEXT": "Contact didn't pick up",
      "MISSED_CALL": "Missed call",
      "MISSED_CALL_INBOUND_SUBTEXT": "No agent picked up",
      "MISSED_CALL_DECLINED_BY": "Declined by {agentName}",
      "CALL_ENDED": "Call ended",
      "HANDLED_BY": "Handled by {agentName}",
      "NOT_ANSWERED_YET": "Not answered yet",
      "CALLING": "Calling…",
      "THEY_ANSWERED": "They answered",
      "YOU_ANSWERED": "You answered",
      "AGENT_ANSWERED": "{agentName} answered",
      "JOIN_CALL": "Join call",
      "CALL_BACK": "Call back",
      "TRANSCRIPT_SHOW_MORE": "Show more",
      "TRANSCRIPT_SHOW_LESS": "Show less"
    },
    "HEADER": {
      "RESOLVE_ACTION": "解決する",
      "REOPEN_ACTION": "再開する",
      "OPEN_ACTION": "再開する",
      "MORE_ACTIONS": "More actions",
      "OPEN": "もっと見る",
      "CLOSE": "閉じる",
      "DETAILS": "詳細",
      "COPY_ID_SUCCESS": "Conversation ID copied to clipboard",
      "SNOOZED_UNTIL": "次の時間までスヌーズ",
      "SNOOZED_UNTIL_TOMORROW": "明日までスヌーズしました",
      "SNOOZED_UNTIL_NEXT_WEEK": "来週までスヌーズ",
      "SNOOZED_UNTIL_NEXT_REPLY": "次の返信までうたた寝。",
      "WHATSAPP_CALL": "Start WhatsApp call",
      "WHATSAPP_CALL_FAILED": "Could not start the WhatsApp call.",
      "VOICE_CALL": "Start call",
      "VOICE_CALL_FAILED": "Could not start the call.",
      "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
      "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "不在",
        "DUE": "期限"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "保留としてマークする",
      "SNOOZE_UNTIL": "スヌーズ",
      "SNOOZE": {
        "TITLE": "までスヌーズする",
        "NEXT_REPLY": "次の返信",
        "TOMORROW": "明日",
        "NEXT_WEEK": "次週"
      }
    },
    "MENTION": {
      "AGENTS": "担当者",
      "TEAMS": "チーム"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "までスヌーズする",
      "APPLY": "スヌーズ",
      "CANCEL": "キャンセル"
    },
    "PRIORITY": {
      "TITLE": "優先度",
      "OPTIONS": {
        "NONE": "該当なし",
        "URGENT": "緊急",
        "HIGH": "高",
        "MEDIUM": "中",
        "LOW": "低"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "該当なし",
        "INPUT_PLACEHOLDER": "優先度を選択",
        "NO_RESULTS": "結果が見つかりませんでした",
        "SUCCESSFUL": "会話ID {conversationId} の優先度を {priority}に変更しました",
        "FAILED": "優先度を変更できませんでした。もう一度お試しください。"
      }
    },
    "DELETE_CONVERSATION": {
      "TITLE": "Delete conversation #{conversationId}",
      "DESCRIPTION": "Are you sure you want to delete this conversation?",
      "CONFIRM": "削除"
    },
    "CARD_CONTEXT_MENU": {
      "PENDING": "保留としてマークする",
      "RESOLVED": "解決済みとしてマークする",
      "MARK_AS_UNREAD": "未読にする",
      "MARK_AS_READ": "既読にする",
      "REOPEN": "会話を再開する",
      "SNOOZE": {
        "TITLE": "スヌーズ",
        "NEXT_REPLY": "次の返信まで",
        "TOMORROW": "明日まで",
        "NEXT_WEEK": "来週まで"
      },
      "ASSIGN_AGENT": "エージェントを割り当てる",
      "ASSIGN_LABEL": "ラベルを割り当てる",
      "AGENTS_LOADING": "エージェントを読み込む...",
      "ASSIGN_TEAM": "チームを割り当てる",
      "DELETE": "Delete conversation",
      "OPEN_IN_NEW_TAB": "Open in new tab",
      "COPY_LINK": "Copy conversation link",
      "COPY_LINK_SUCCESS": "Conversation link copied to clipboard",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "会話 ID {conversationId} が \"{agentName}\" に割り当てられました",
          "FAILED": "エージェントを割り当てられませんでした。もう一度お試しください。"
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "会話ID {conversationId} に ラベル #{labelName} を割り当てました",
          "FAILED": "ラベルを割り当てることができませんでした。もう一度やり直してください。"
        },
        "LABEL_REMOVAL": {
          "SUCCESFUL": "Removed label #{labelName} from conversation id {conversationId}",
          "FAILED": "Couldn't remove label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "会話ID {conversationId} に \"{team}\" チームを割り当てました",
          "FAILED": "チームを割り当てることができませんでした。もう一度お試しください。"
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "メッセージの署名",
      "ENABLE_SIGN_TOOLTIP": "署名を有効化",
      "DISABLE_SIGN_TOOLTIP": "署名を無効化",
      "MSG_INPUT": "Shift + Enter で新しい行を作成します。「/」で開始すると、定型文回答を選択できます。",
      "PRIVATE_MSG_INPUT": "Shift + Enter で新しい行を作成します。これは担当者にのみ表示されます。",
      "MESSAGING_RESTRICTED": "You cannot reply to this conversation",
      "MESSAGING_RESTRICTED_WHATSAPP": "You can only reply using a template message due to 24-hour message window restriction",
      "MESSAGING_RESTRICTED_API": "You can only reply using a template message due to message window restriction",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "メッセージ署名が構成されていません。プロフィール設定で構成してください。",
      "COPILOT_MSG_INPUT": "Copilot に追加のプロンプトを送るか、ほかの質問をしてください… Enter キーでフォローアップを送信",
      "CLICK_HERE": "ここをクリックして更新",
      "WHATSAPP_TEMPLATES": "Whatsapp テンプレート"
    },
    "REPLYBOX": {
      "REPLY": "返信",
      "PRIVATE_NOTE": "非公開メモ",
      "SEND": "送信",
      "CREATE": "メモを追加",
      "INSERT_READ_MORE": "続きを読む",
      "DISMISS_REPLY": "返信を却下",
      "REPLYING_TO": "返信対象：",
      "TIP_EMOJI_ICON": "絵文字セレクタを表示",
      "TIP_ATTACH_ICON": "ファイルを添付",
      "TIP_AUDIORECORDER_ICON": "音声を録音",
      "TIP_AUDIORECORDER_PERMISSION": "音声アクセスを許可",
      "TIP_AUDIORECORDER_ERROR": "音声を開けませんでした",
      "AUDIO_CONVERSION_FAILED": "Audio conversion failed. Please try again.",
      "DRAG_DROP": "添付するにはここにドラッグ＆ドロップ",
      "START_AUDIO_RECORDING": "音声録音を開始",
      "STOP_AUDIO_RECORDING": "音声録音を停止",
      "COPILOT_THINKING": "Copilotが考え中",
      "EMAIL_HEAD": {
        "TO": "宛先",
        "ADD_BCC": "Bcc を追加",
        "CC": {
          "LABEL": "Cc",
          "PLACEHOLDER": "カンマで区切ったメールアドレス",
          "ERROR": "有効なメールアドレスを入力してください"
        },
        "BCC": {
          "LABEL": "Bcc",
          "PLACEHOLDER": "カンマで区切ったメールアドレス",
          "ERROR": "有効なメールアドレスを入力してください"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "未定義の変数",
        "MESSAGE": "メッセージに {undefinedVariablesCount} 個の未定義変数があります：{undefinedVariables}。それでもメッセージを送信しますか？",
        "CONFIRM": {
          "YES": "送信",
          "CANCEL": "キャンセル"
        }
      },
      "QUOTED_REPLY": {
        "ENABLE_TOOLTIP": "Include quoted email thread",
        "DISABLE_TOOLTIP": "Don't include quoted email thread",
        "REMOVE_PREVIEW": "Remove quoted email thread",
        "COLLAPSE": "Collapse preview",
        "EXPAND": "Expand preview"
      }
    },
    "VISIBLE_TO_AGENTS": "非公開設定の注意：あなたとあなたのチームのみに表示されます",
    "CHANGE_STATUS": "会話の状態が変更されました",
    "CHANGE_STATUS_FAILED": "会話の状態変更に失敗しました",
    "CHANGE_AGENT": "会話の担当者が変更されました",
    "CHANGE_AGENT_FAILED": "担当者の変更に失敗しました",
    "ASSIGN_LABEL_SUCCESFUL": "ラベルが正常に割り当てられました",
    "ASSIGN_LABEL_FAILED": "ラベル割り当てに失敗しました",
    "CHANGE_TEAM": "会話のチームが変更されました",
    "SUCCESS_DELETE_CONVERSATION": "Conversation deleted successfully",
    "FAIL_DELETE_CONVERSATION": "Couldn't delete conversation! Try again",
    "FILE_SIZE_LIMIT": "ファイルが {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB の添付ファイル制限を超えています",
    "FILE_TYPE_NOT_SUPPORTED": "This {fileName} file type is not supported in this conversation",
    "MESSAGE_ERROR": "このメッセージを送信できません。後でもう一度お試しください",
    "SENT_BY": "送信者：",
    "BOT": "ボット",
    "NATIVE_APP": "Native app",
    "NATIVE_APP_ADVISORY": "This message was sent from the native app. Reply from Chatwoot to maintain the message window.",
    "SEND_FAILED": "メッセージを送信できませんでした！再試行してください",
    "TRY_AGAIN": "再試行",
    "ASSIGNMENT": {
      "SELECT_AGENT": "担当者を選択",
      "REMOVE": "削除",
      "ASSIGN": "割り当てる"
    },
    "CONTEXT_MENU": {
      "COPY": "コピー",
      "REPLY_TO": "このメッセージに返信",
      "DELETE": "削除",
      "CREATE_A_CANNED_RESPONSE": "定型文応答に追加",
      "TRANSLATE": "翻訳",
      "COPY_PERMALINK": "メッセージへのリンクをコピー",
      "LINK_COPIED": "メッセージのURLがクリップボードにコピーされました",
      "DELETE_CONFIRMATION": {
        "TITLE": "このメッセージを削除してもよろしいですか？",
        "MESSAGE": "この操作は元に戻せません",
        "DELETE": "削除",
        "CANCEL": "キャンセル"
      }
    },
    "SIDEBAR": {
      "CONTACT": "連絡先",
      "COPILOT": "コパイロット"
    },
    "VOICE_WIDGET": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NOT_ANSWERED_YET": "Not answered yet",
      "HANDLED_IN_ANOTHER_TAB": "Being handled in another tab",
      "REJECT_CALL": "Reject",
      "DISMISS_CALL": "閉じる",
      "JOIN_CALL": "Join call",
      "END_CALL": "End call",
      "MUTE": "Mute mic",
      "UNMUTE": "Unmute mic",
      "VIEW_CHAT_HISTORY": "View chat history",
      "GO_TO_CONVERSATION": "Go to conversation thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "会話の記録を送信",
    "DESC": "会話記録のコピーを指定されたメールアドレスに送信する",
    "SUBMIT": "送信",
    "CANCEL": "キャンセル",
    "SEND_EMAIL_SUCCESS": "チャットの記録は正常に送信されました",
    "SEND_EMAIL_ERROR": "エラーが発生しました。もう一度お試しください。",
    "SEND_EMAIL_PAYMENT_REQUIRED": "Email transcript is not available on your current plan. Please upgrade to use this feature.",
    "FORM": {
      "SEND_TO_CONTACT": "顧客に会話の記録を転送する",
      "SEND_TO_AGENT": "担当者に記録を送信する",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "会話の記録を別のメールアドレスに転送する",
      "EMAIL": {
        "PLACEHOLDER": "メールアドレスを入力する",
        "ERROR": "正しいメールアドレスを入力してください"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "こんにちは 👋, {installationName}へようこそ！",
    "DESCRIPTION": "ご登録いただきありがとうございます。{installationName} を最大限に活用していただくために、いくつかのヒントをご紹介します。",
    "GREETING_MORNING": "おはようございます 👋, {name} さん。{installationName} へようこそ。",
    "GREETING_AFTERNOON": "こんにちは 👋, {name} さん。{installationName} へようこそ。",
    "GREETING_EVENING": "こんばんは 👋, {name} さん。{installationName} へようこそ。",
    "READ_LATEST_UPDATES": "最新のアップデートを読む",
    "ALL_CONVERSATION": {
      "TITLE": "すべての会話を1箇所で",
      "DESCRIPTION": "お客様からのすべての会話を1つのダッシュボードで確認できます。受信チャネル、ラベル、ステータスでフィルタリング可能です。",
      "NEW_LINK": "ここをクリックして受信トレイを作成"
    },
    "TEAM_MEMBERS": {
      "TITLE": "チームメンバーを招待",
      "DESCRIPTION": "お客様と話す準備が整ったら、チームメイトを招待して支援を受けましょう。担当者リストにメールアドレスを追加して、チームメンバーを招待できます。",
      "NEW_LINK": "ここをクリックしてチームメンバーを招待"
    },
    "LABELS": {
      "TITLE": "ラベルで会話を整理",
      "DESCRIPTION": "ラベルを使うと、会話を簡単に分類できます。#support-enquiry、#billing-question などのラベルを作成して、後で会話に活用してください。",
      "NEW_LINK": "ここをクリックしてラベルを作成"
    },
    "CANNED_RESPONSES": {
      "TITLE": "定型文応答を作成",
      "DESCRIPTION": "あらかじめ用意されたクイック返信テンプレートで、会話に迅速に対応できます。担当者は '/' を入力し、その後にショートコードを入力して返信を挿入できます。",
      "NEW_LINK": "ここをクリックして定型文応答を作成"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "担当者",
    "SELF_ASSIGN": "自分に割り当て",
    "TEAM_LABEL": "担当チーム",
    "SELECT": {
      "PLACEHOLDER": "なし"
    },
    "ACCORDION": {
      "CONTACT_DETAILS": "連絡先詳細",
      "CONVERSATION_ACTIONS": "会話のアクション",
      "CONVERSATION_LABELS": "会話のラベル",
      "CONVERSATION_INFO": "会話の情報",
      "CONTACT_NOTES": "Contact Notes",
      "CONTACT_ATTRIBUTES": "連絡先属性",
      "PREVIOUS_CONVERSATION": "以前の会話",
      "MACROS": "マクロ",
      "LINEAR_ISSUES": "Linked Linear Issues",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "SHARED_FILES": "Attachments"
    },
    "SHARED_FILES": {
      "EMPTY": "No attachments yet",
      "DOWNLOAD": "Download file",
      "DOWNLOAD_ERROR": "Could not download the file. Please try again.",
      "MEDIA_HEADING": "Media",
      "FILES_HEADING": "Files",
      "VIEW_ALL": "すべて表示",
      "SHOW_LESS": "Show less",
      "MORE_COUNT": "+{count}",
      "UNTITLED_FILE": "Untitled file"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "保留中",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "属性を作成",
    "NO_RECORDS_FOUND": "属性が見つかりません",
    "UPDATE": {
      "SUCCESS": "属性が正常に更新されました",
      "ERROR": "属性を更新できませんでした。後でもう一度お試しください"
    },
    "ADD": {
      "TITLE": "追加",
      "SUCCESS": "属性が正常に追加されました",
      "ERROR": "属性を追加できませんでした。後でもう一度お試しください"
    },
    "DELETE": {
      "SUCCESS": "属性が正常に削除されました",
      "ERROR": "属性を削除できませんでした。後でもう一度お試しください"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "属性を追加",
      "PLACEHOLDER": "属性を検索",
      "NO_RESULT": "属性が見つかりません"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "差出人:",
    "TO": "宛先:",
    "BCC": "ビーシーシー",
    "CC": "シーシー",
    "SUBJECT": "件名",
    "EXPAND": "メールを展開"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "参加者",
    "SIDEBAR_TITLE": "会話の参加者",
    "NO_RECORDS_FOUND": "結果が見つかりません",
    "ADD_PARTICIPANTS": "参加者を選択",
    "REMANING_PARTICIPANTS_TEXT": "+{count} 人のその他",
    "REMANING_PARTICIPANT_TEXT": "+{count} 人のその他",
    "TOTAL_PARTICIPANTS_TEXT": "{count} 人が参加しています。",
    "TOTAL_PARTICIPANT_TEXT": "{count} 人が参加しています。",
    "NO_PARTICIPANTS_TEXT": "誰も参加していません。",
    "WATCH_CONVERSATION": "会話に参加",
    "YOU_ARE_WATCHING": "あなたはこの会話に参加しています",
    "API": {
      "ERROR_MESSAGE": "更新できませんでした。再試行してください！",
      "SUCCESS_MESSAGE": "参加者が更新されました！"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "翻訳されたコンテンツを表示",
    "DESC": "各言語で翻訳されたコンテンツを表示できます。",
    "ORIGINAL_CONTENT": "オリジナルコンテンツ",
    "TRANSLATED_CONTENT": "翻訳されたコンテンツ",
    "NO_TRANSLATIONS_AVAILABLE": "このコンテンツには翻訳が利用できません"
  },
  "TYPING": {
    "ONE": "{user} が入力中...",
    "TWO": "{user} と {secondUser} が入力中...",
    "MULTIPLE": "{user} と他 {count} 人が入力中..."
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "これらのプロンプトを試してください"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "添付ファイルをダウンロードできませんでした。もう一度お試しください。"
  }
}
